
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/informe-de-nieve",
      function () {
        return require("private-next-pages/[region]/informe-de-nieve.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/informe-de-nieve"])
      });
    }
  